module.exports = __webpack_public_path__ + "static/media/organization-active.6f3d71a4.svg";